if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.mobileMedia = window.matchMedia('(max-width: 749px)');
        this.resetMobileZoom();
        this.addEventListener('touchstart', this.startMobileGesture.bind(this), { passive: false });
        this.addEventListener('touchmove', this.moveMobileGesture.bind(this), { passive: false });
        this.addEventListener('touchend', this.endMobileGesture.bind(this), { passive: false });
        this.addEventListener('touchcancel', () => { this.mobileGesture = null; });
        this.mobileMedia.addEventListener('change', () => this.resetMobileZoom());
      }

      hide() {
        this.resetMobileZoom();
        super.hide();
      }

      resetMobileZoom() {
        this.querySelectorAll('.product-media-modal__content > img').forEach((image) => {
          image.style.removeProperty('transform');
        });
        this.mobileScale = 1;
        this.mobileX = 0;
        this.mobileY = 0;
        this.mobileGesture = null;
        this.mobileLastTap = 0;
      }

      mobileImage() {
        return this.querySelector('.product-media-modal__content > img.active');
      }

      renderMobileZoom() {
        const image = this.mobileImage();
        if (!image) return;
        const container = image.parentElement;
        const maxX = Math.max(0, (image.offsetWidth * this.mobileScale - container.clientWidth) / 2);
        const maxY = Math.max(0, (image.offsetHeight * this.mobileScale - container.clientHeight) / 2);
        this.mobileX = Math.max(-maxX, Math.min(maxX, this.mobileX));
        this.mobileY = Math.max(-maxY, Math.min(maxY, this.mobileY));
        image.style.transform = `translate(${this.mobileX}px, ${this.mobileY}px) scale(${this.mobileScale})`;
      }

      startMobileGesture(event) {
        if (!this.mobileMedia.matches || !this.hasAttribute('open') || event.target !== this.mobileImage()) return;
        event.preventDefault();
        const first = event.touches[0];
        const second = event.touches[1];
        this.mobileGesture = {
          x: first.clientX, y: first.clientY,
          panX: this.mobileX, panY: this.mobileY,
          scale: this.mobileScale,
          distance: second ? Math.hypot(second.clientX - first.clientX, second.clientY - first.clientY) : 0,
          pinch: Boolean(second), moved: false,
          dx: 0, dy: 0, started: Date.now()
        };
      }

      moveMobileGesture(event) {
        const gesture = this.mobileGesture;
        if (!this.mobileMedia.matches || !gesture) return;
        event.preventDefault();
        const first = event.touches[0];
        const second = event.touches[1];
        if (!first) return;
        gesture.dx = first.clientX - gesture.x;
        gesture.dy = first.clientY - gesture.y;
        if (Math.hypot(gesture.dx, gesture.dy) > 8) gesture.moved = true;
        if (second && gesture.distance) {
          const distance = Math.hypot(second.clientX - first.clientX, second.clientY - first.clientY);
          this.mobileScale = Math.max(1, Math.min(4, gesture.scale * distance / gesture.distance));
        } else if (!gesture.pinch && this.mobileScale > 1) {
          this.mobileX = gesture.panX + gesture.dx;
          this.mobileY = gesture.panY + gesture.dy;
        }
        this.renderMobileZoom();
      }

      endMobileGesture(event) {
        const gesture = this.mobileGesture;
        if (!this.mobileMedia.matches || !gesture) return;
        event.preventDefault();
        if (event.touches.length) return;
        this.mobileGesture = null;
        if (gesture.pinch) { this.mobileLastTap = 0; return; }
        if (this.mobileScale === 1 && Math.abs(gesture.dx) > 50 && Math.abs(gesture.dx) > Math.abs(gesture.dy) * 1.3) {
          const images = Array.from(this.querySelectorAll('.product-media-modal__content > img[data-media-id]'));
          const index = images.indexOf(this.mobileImage());
          const next = images[index + (gesture.dx < 0 ? 1 : -1)];
          if (next) {
            this.resetMobileZoom();
            images.forEach((image) => image.classList.toggle('active', image === next));
          }
          this.mobileLastTap = 0;
          return;
        }
        if (!gesture.moved && Date.now() - gesture.started < 300) {
          const now = Date.now();
          if (this.mobileLastTap && now - this.mobileLastTap < 320) {
            this.mobileScale = this.mobileScale > 1 ? 1 : 2.5;
            this.mobileX = 0;
            this.mobileY = 0;
            this.renderMobileZoom();
            this.mobileLastTap = 0;
          } else this.mobileLastTap = now;
        } else this.mobileLastTap = 0;
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.resetMobileZoom();
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
